@switch (state()) {
  @case ('loading') {
    <div class="flex flex-col gap-3 p-4" data-cy="snapshots-loading">
      @for (row of skeletonRows; track row) {
        <div class="flex flex-col gap-2">
          <div class="h-3 w-1/2 animate-pulse rounded bg-border-2"></div>
          <div class="h-3 w-3/4 animate-pulse rounded bg-border-2"></div>
        </div>
      }
    </div>
  }

  @case ('error') {
    <div class="flex flex-col items-start gap-3 p-4" data-cy="snapshots-error">
      <p class="text-sm">{{ 'store-history.we-could-not-load-your-snapshots' | translate }}</p>

      <button mat-stroked-button data-cy="snapshots-retry" (click)="load()">{{ 'common.retry' | translate }}</button>
    </div>
  }

  @case ('empty') {
    <div class="flex flex-col items-start gap-2 p-4" data-cy="snapshots-empty">
      <p class="text-sm font-semibold">{{ 'store-history.no-snapshots-yet' | translate }}</p>
      <p class="text-sm text-brand-600">
        {{ 'store-history.a-snapshot-is-taken-only-on-days-you-change-something' | translate }}
      </p>
    </div>
  }

  @default {
    @for (snapshot of snapshots(); track snapshot.id) {
      <div
        class="flex items-start gap-2 border-b border-solid border-border-2 px-4 py-3"
        [attr.data-cy]="'snapshot-row-' + snapshot.id"
      >
        <div class="flex min-w-0 flex-1 flex-col">
          <div class="flex items-center gap-2">
            <span class="text-sm font-medium">{{ snapshot.takenAt | date: 'medium' }}</span>
            <span
              class="rounded bg-primary/10 px-1.5 py-0.5 text-xs text-brand-600"
              [attr.data-cy]="'snapshot-trigger-' + snapshot.id"
            >
              {{ triggerKey(snapshot) | translate }}
            </span>
          </div>

          <span class="mt-0.5 text-xs text-brand-600" [attr.data-cy]="'snapshot-counts-' + snapshot.id">
            @for (summary of summarised; track summary.collection; let last = $last) {
              {{ summary.key | translate: { x: count(snapshot, summary.collection) } }}{{ last ? '' : ' · ' }}
            }
          </span>
        </div>

        <button
          mat-stroked-button
          class="!h-7 !text-xs"
          [attr.data-cy]="'snapshot-restore-' + snapshot.id"
          (click)="onRestore(snapshot)"
        >
          {{ 'store-history.restore' | translate }}
        </button>
      </div>
    }

    <!-- The single sentence that explains every gap in the list. It is not decoration. -->
    <p class="px-4 py-3 text-xs text-brand-600" data-cy="snapshots-gap-explanation">
      {{ 'store-history.a-snapshot-is-taken-only-on-days-you-change-something' | translate }}
    </p>
  }
}
